Object.defineProperty(exports, "__esModule", { value: true });
exports.DEV_SERVER_PATTERN = void 0;
exports.DEV_SERVER_PATTERN = /localhost[:]?/i;
function isDevServer(url) {
    const urlToTest = url || window.location.host;
    return exports.DEV_SERVER_PATTERN.test(urlToTest);
}
exports.default = isDevServer;
//# sourceMappingURL=isDevServer.js.map